module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _vm._v("Copyright © 2018 by University of Massachusetts Press")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("ISBN 978-1-61376-575-3")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Cover design by Kristina Kachele Design, llc")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover art: Lovesiyu, "), _c('i', [_vm._v("Peony")]), _vm._v(" © 123RF.com")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("A catalog record for this book is available from the Library of Congress.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("British Library Cataloguing-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("A catalog record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Reference material in “The Birthday Girls” from "), _c('i', [_vm._v("Bodhisattva of Compassion")]), _vm._v(" by John Blofeld. Courtesy of Shambhala Publications.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-feb9bbc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma-HUANG-0006.vue
// module id = 72
// module chunks = 0